<template>
	<div class="jobModule">
		<el-container style="flex-direction: column;">
			<NJNav></NJNav>
			<div class="select-block">
				<div class="mapBox">

					<!--<div class="mapTitle">
						<b>{{ cityName }}农机补贴机具分布热力图<br/><span>统计时间：{{currentdateText}}</span></b>
					</div>-->
					<div class="tab-box">
						<div class="times">
							<p>农机补贴机具分布热力图</p>
							<p>统计时间：截止到{{ currentdateText }}</p>
						</div>
					</div>
					<div id="container" class="myMap">
						<div id="mapMain" style="width: 100%; height: 100%"></div>
						<div class="mapAllText">
							<ul class="njClass">
								<li v-for="(item,index) in tabArr" :class="[{'active':isActive == index},'items'+item.icon]" @click="tabClick(index, item)" :key="index">
									<!-- <img :src="item.iconImg" alt=""> -->
									<p>
										{{item.catThreeName}}<br />
										<span>{{item.njNum}}</span>台
									</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<!--<div v-show="dialogMapDetail" class="dialogMapDetail myDialog">
				<div class="dialogWrap">
					<div class="dialogTitle">{{this.dataTitle.njName}}作业信息</div>
					<div class="dialogClose" @click="dialogMapClick2">×</div>
					<div class="dialogMap">
						<div id="containers" class="myMapDialog">
						</div>
						<div class="dialogMapText">
							<table>
								<tr>
									<td>监控编号：{{this.dataTitle.imei}}</td>
									<td>机具型号：{{this.dataTitle.productModel}}</td>
									<td>出厂编号：{{this.dataTitle.factoryCode}}</td>
									<td>作业时间：{{this.dataTitle.operatTime}}</td>
									<td>作业地区：{{this.dataTitle.workArea}}</td>

								</tr>

							</table>

						</div>
						<div id="tools" v-show="statusStatic">
							<div class="btns">
								<ul class="speedUp" v-show="popVisible">
									<li v-for="(item,index) in speedList" :class="{'speedActive':index==speedIsActive}" @click.stop="handlePlay('accelerate',index)">{{item.speedTimes}}</li>
								</ul>
								<dl :class="calendarFlag == true?'img-onlyRead':''" @click.stop="speedChange('slowdown')">
									<dt id="moderatingBtn">
												<img src="/static/bofang/jiansu.png" />
											</dt>
									<dd>减速</dd>
								</dl>
								<dl>
									<dt id="pauseBtn" @click='handlePlay(operationForPauseAndContinue)'>
									<img :src="continueOrStopUrl" />

								</dt>
									<dd id="pauseBtns">开始</dd>
								</dl>

								<dl :class="calendarFlag == true?'img-onlyRead':''" @click.stop="speedChange('accelerate')">
									<dt id="acceleratedBtn">
												<img src="/static/bofang/jiasu.png" />
											</dt>
									<dd>加速</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
			</div>-->
			<div v-show="dialogMapDetail" class="dialogMapDetail myDialog">
				<div class="dialogWrap">
					<div class="dialogTitle">{{this.dataTitle.njName}}作业信息</div>
					<div class="dialogClose" @click="dialogMapDetailClick">×</div>
					<TrackLayer ref="trackLayer" :imei="imei" :collectTime="collectTime" :id="njId" :statusStatic="statusStatic"></TrackLayer>
				</div>
			</div>
			<div class="historyDialog myDialog" v-show="historyDialog">
				<div class="dialogWrap">
					<!--<div class="dialogTitle">{{this.dataTitle.njName}}作业信息</div>-->
					<div class="dialogClose" @click="dialogMapDetailClick">×</div>
					<DiscountDetailsDialog :imei="imei" :id="njId" :source="source" :qrNumber="qrNumber" :sourceId="sourceId"></DiscountDetailsDialog>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import "echarts/map/js/china.js"
	import Gmap from "../../map/js/fzTianmap.js";
	import Api from "../../Serves/net-api.js";
	import Http from "../../Serves/net-http.js";
	import NJNav from '../Index/view/NJNav'
	//import { getStore, setStore } from '@/utils/storage'
	import 'maptalks/dist/maptalks.css'
	import * as maptalks from 'maptalks'
	import { HeatLayer } from 'maptalks.heatmap';
	import TalksMap from '../../map/js/initMapTalks.js'
	import TRecordItemDialog from './TRecordItemDialog.vue'
	import DiscountDetailsDialog from './DiscountDetailsDialog.vue'
	import { mapState, mapActions, mapMutations } from "vuex";
	import TrackLayer from './trackLayer.vue'
	export default {
		name: "Monitor",
		components: {
			NJNav,
			TRecordItemDialog,
			DiscountDetailsDialog,
			TrackLayer
		},
		data() {
			return {
				Gmaps: new Gmap(),
				dialogMapDetail: false,
				dataTitle: '',
				TalksMap: new TalksMap(),
				dataTitleShow: true,
				runTimeDay: '',
				operatArea: '',
				currentDate: '',
				tabArr: [],
				isActive: 0,
				cityName: this.$store.state.info.govLevel === 1 ? '本市' : '',
				pointData1: [],
				pointData2: [],
				pointData5: [],
				allPointsData: [],
				setMarkersData: [],
				historyDialog: false,
				workDialog: false,
				imei: '',
				njId: '',
				collectTime: '',
				currentdateText: '',
				calendarFlag: true,
				startContinue: "start",
				operationForPauseAndContinue: "start",
				map: "",
				stopedIndex: 0,
				trackList: [],
				getGjTime: '',
				requestTimer: null,
				lastRequestData: [],
				statusStatic: true,
				zanting: require('/static/bofang/zanting.png'),
				kaishi: require('/static/bofang/start.png'),
				continueOrStopUrl: require('/static/bofang/start.png'),
				tingzhi: require('/static/bofang/tingzhi.png'),
				speedList: [{
					'speedTimes': '0.5X',
					'speed': 800,
				}, {
					'speedTimes': '1X',
					'speed': 400,
				}, {
					'speedTimes': '2X',
					'speed': 200,
				}, {
					'speedTimes': '3X',
					'speed': 133,
				}],
				speedIsActive: 1,
				popVisible: false,
				itemId: '',
				workType_key: '',
        njClassName: '',
        sourceId: '',
        source: '',
        qrNumber: ''
			}
		},
		beforeDestroy() {
			// 清除当前页定时器
			if(this.requestTimer) {
				clearInterval(this.requestTimer);
				this.timer = null;
			}
		},
		computed: {
			...mapState({
				handleName: state => state.kName,
			})
		},
		watch: {
			handleName(newVal, oldVal) {
				if(newVal == 'end') {
					this.operationForPauseAndContinue = 'start'
					document.getElementById("pauseBtns").innerHTML = "开始";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
					this.popVisible = false;
				}
			}
		},
		created() {
			let _this = this;
			window.viewHistory = _this.viewHistory;
			window.viewCurrentLine = _this.viewCurrentLine;
		},
		mounted() {
			let this_ = this;
			this.currentDate = this.getNowFormatDates()
			this.collectTimeEnd = this.getNowFormatDates() + ' 23:59:59'
			this.$nextTick(() => {
				this.initMapTalk()
			})
			this.TalksMap.sendThis(this);
			document.addEventListener('click', function(e) {
				if(this_.popVisible === true) {
					this_.popVisible = false
				}
			})

		},
		methods: {
			// 农机分类tab切换
			tabClick(index, item) {
				this.isActive = index
        // this.TalksMap.map.setZoom(5)
        // if(window.location.host === 'ningbo.dtwl360.com' || window.location.host === 'xiamen.dtwl360.com') {
        //   this.TalksMap.map.setZoom(10);
        // } else if (window.location.host === 'beijing.dtwl360.com'){
        //   this.TalksMap.map.setZoom(8);
        // } else {
        //   this.TalksMap.map.setZoom(3)
		// }
		this.TalksMap.map.setZoom(4)
        this.catThreeCode=item.catThreeCode;
				this.allPointLayer.clear();
				this.allHeatLayer.clear();
				this.getHeatLayer()
				// this.allHeatLayer.setData(data)
			},
			// 获取当前月
			getNowFormatDates() {
				var date = new Date()
				var seperator1 = '-'
				var year = date.getFullYear()
				var month = date.getMonth() + 1
				var strDate = date.getDate()
				if(month >= 1 && month <= 9) {
					month = '0' + month
				}
				if(strDate >= 0 && strDate <= 9) {
					strDate = '0' + strDate
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate
				this.currentdateText = year + '年' + month + '月' + strDate + '日'

				return currentdate
			},
			// 机具总数
			newCountNjNumByMachineType() {
					Api.doPost(Http.homePageStatisByJSController.countNjNumHeatMapStatis, {
						year:new Date().getFullYear()
				}, false, res => {
					// this.tabArr = res.result.list
					// this.tabArr.unshift({
					//   num: res.result.totalNum,
					//   id: '',
					//   machineName: '机具总数'
					// })
					this.tabArr = res.result
					this.catThreeCode=res.result[0].catThreeCode
          // if(res.result.list.length === 4) {
          //   this.njClassName = 'njClass-m'
          // } else if(res.result.list.length === 6) {
          //   this.njClassName = 'njClass-s'
          // } else if(res.result.list.length === 3) {
          //   this.njClassName = 'njClass-t'
          // } else if (res.result.list.length === 5) {
          //   this.njClassName = 'njClass-f'
          // }
          // this.tabArr.unshift({
          //   icon:0,
          //   num: res.result.totalNum,
          //   id: '',
          //   machineName: '全部农机'
          // })

					// console.log(this.tabArr)
					this.getHeatLayer();
				})
			},
      // 获取区县边界
      getCityBorderByViewCenter () {
        let info = JSON.parse(localStorage.getItem('vuex')).info;
				var parmse = {
					adcode: this.$store.state.Code?this.$store.state.Code:info.areaCode,
					level: this.$store.state.info.govLevel?this.$store.state.info.govLevel:info.govLevel
				}
				Api.doPost(Http.gis.getCityBorderByViewCenter, parmse, false, (res) => {
					let Coordinate = {
						x: res.result.properties.lng,
						y: res.result.properties.lat
					};
					this.TalksMap.map.setCenter(Coordinate);
					this.TalksMap.drawCountyLine(res.result.geometry)

				})
      },
			// 初始化地图
			initMapTalk() {
				let this_ = this
				this.TalksMap.init("mapMain")

				this.allPointLayer = new maptalks.VectorLayer('point').addTo(this.TalksMap.map)
				this.allHeatLayer = new HeatLayer('heat').addTo(this.TalksMap.map)

				function getRandomNumberByRange(start, end) {
					return Number((Math.random() * (end - start) + start).toFixed(2))
				}
				this.$nextTick(() => {
          this.newCountNjNumByMachineType()
          // if(JSON.parse(sessionStorage.getItem("allHeatLayer")) && JSON.parse(sessionStorage.getItem("allHeatLayer")).workType_0) {
          //   this.allData = JSON.parse(sessionStorage.getItem("allHeatLayer"));
          //   this.setHeatLayer()
          // } else {
          //   this.getHeatLayer();
          // }
				})

				let noZoomLevel = new maptalks.control.Zoom({
					position: {
						'bottom': 10,
						'right': 10
					},
					slider: true,
					zoomLevel: true
				})
        this.TalksMap.map.addControl(noZoomLevel)
        // if (window.location.host === 'ningbo.dtwl360.com' || window.location.host === 'xiamen.dtwl360.com') {
        //   this.TalksMap.map.setMinZoom(6);
        //   this.TalksMap.map.setZoom(10);
        // } else if (window.location.host === 'beijing.dtwl360.com'){
        //   this.TalksMap.map.setMinZoom(6);
        //   this.TalksMap.map.setZoom(8);
        // } else {
        //   this.TalksMap.map.setMinZoom(6);
        //   this.TalksMap.map.setZoom(7);
		    // }

        if (this.$store.state.areaName == '无锡市') {
					this.TalksMap.map.setMinZoom(8);
					this.TalksMap.map.setZoom(9);
					

				} else if (window.location.host == 'localhost:8081'|| this.$store.state.areaName == '江苏省') {
          this.TalksMap.map.setMinZoom(5);
					this.TalksMap.map.setZoom(7.6);
        }else{
        		this.TalksMap.map.setMinZoom(4);
          this.TalksMap.map.setZoom(6)
        }
         this.$nextTick(() => {
					setTimeout(() => {
					this_.getCityBorderByViewCenter()
				})
				})
				
          
			
				// let Coordinate = {
				// 	x: 106.210355,
				// 	y: 36.658856
				// }
				// this.TalksMap.map.setCenter(Coordinate)

				//  级别变化事件
				//  级别变化事件
				this.TalksMap.map.on('zoomend', function(e) {
					this_.zoomEnd = e.to
					if(e.to >= 12) { //级别大于12加载地块
						if(this_.allPointLayer.getCount() == 0) {
							let data = this_.TalksMap.map.getExtent()
							this_.getMarkers(data)
						}

					}
					if(e.to < 12 && this_.allHeatLayer.getData().length > 0) { //级别小于16删除地块
						this_.allHeatLayer.show();
						this_.allPointLayer.clear();
					}

				})
				//  移动地图事件
				this.TalksMap.map.on('movestart', function(e) {
					this.startPoint = e.containerPoint || e.target.startPoint
				})
				this.TalksMap.map.on('moveend', function(e) { //移动地图结束，计算移动到一定距离加载地块
					this.endPoint = e.containerPoint || e.target.endPoint
					var a = this.startPoint ? this.endPoint.x - this.startPoint.x : 0
					var b = this.startPoint ? this.endPoint.y - this.startPoint.y : 0

					var c = Math.sqrt(a * a + b * b)

					if(c > 300 && this_.zoomEnd >= 12) {
						let data = this_.TalksMap.map.getExtent()
						this_.getMarkers(data)
					}
				})

			},
			// 更新实时位置信息接口
			updateCurrentLocation (imei) {
				Api.doPost(
				Http.gis.updateCurrentLocation,
				{
					type: 'gps',
					imei: imei,
					lat: 0,
					lng: 0
				},
				false,
				res => {
					console.log(res)
				})
			},
			// 显示信息窗口
			displayInfoWindow(e) {
				let this_ = this
				let targetPolygon = e.target
				let id = targetPolygon.getProperties().id;
				this.updateCurrentLocation(id)
				if(targetPolygon.getInfoWindow()) {
					targetPolygon.openInfoWindow()
				} else {
					let blockInfo = targetPolygon.properties
					targetPolygon.updateSymbol({
						lineColor: 'blue'
					})
					Api.doPost(Http.gis.getMarkerInfo, {
						imei: id
					}, false, res => {
						var info = res.result
						if(info.collectTime) {
							this.collectTime = info.collectTime.slice(0, 10);
						} else {
							this.collectTime = ''
						}
						this.imei = info.imei;
            this.njId = info.njId;
            this.source = info.source
            this.sourceId = info.sourceId
            this.qrNumber = info.qrNumber
						this.njStatus = info.status;
						this.dataTitle = info;
						this.dataTitle.operatTime = info.collectTime;
            this.dataTitle.workArea = info.currentLocation;
						var content = []
						let statusName = info.status == 1 ? '运动' : '静止'
						if(targetPolygon.getProperties() == '其它') {
							if(this.collectTime.substring(0, 10) == this.getNowFormatDates()) {
								content = [
									'<div style=" font-size:11px; width: 410px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
									'<li>监控编号：', id, '</li>',
									'<li>采集时间：', info.collectTime, '</li>',
									'<li>当前状态：', statusName, "<span style='margin-left:3vw;'>累计作业面积：" + info.sumArea + '亩</span></li>',
									'<li>当前位置：', info.currentLocation, '</li></ul>',
									'<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
									'<button class="Cancel viewMoreDialog" onclick="viewCurrentLine()">当日轨迹</button>',
									'</div>'
								]
							} else {
								content = [
									'<div style=" font-size:11px; width: 410px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
									'<li>监控编号：', id, '</li>',
									'<li>采集时间：', info.collectTime, '</li>',
									'<li>当前状态：', statusName, "<span style='margin-left:3vw;'>累计作业面积：" + info.sumArea + '亩</span></li>',
									'<li>当前位置：', info.currentLocation, '</li></ul>',
									'<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
									'<button class="Cancel" style="display:none"></button>',
									'</div>'
								]
							}
						} else {
							if(this.collectTime.substring(0, 10) == this.getNowFormatDates()) {
								content = [
									'<div style=" font-size:11px; width: 410px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
									'<li>农机类型：', info.njName, '</li>',
									'<li>农机主：', info.ownerName, '</li>',
									'<li>出厂编号：', info.factoryCode, '</li>',
									'<li>监控编号：', id, '</li>',
									'<li>采集时间：', info.collectTime, '</li>',
									'<li>当前状态：', statusName, "<span style='margin-left:3vw;'>累计作业面积：" + info.sumArea + '亩</span></li>',
									'<li>当前位置：', info.currentLocation, '</li></ul>',
									'<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
									'<button class="Cancel viewMoreDialog" onclick="viewCurrentLine()">当日轨迹</button>',
									'</div>'
								]
							} else {
								content = [
									'<div style=" font-size:11px; width: 410px;display: block;margin: 0px;"> <ul class="mapInfo" style="width:100%;">',
									'<li>农机类型：', info.njName, '</li>',
									'<li>农机主：', info.ownerName, '</li>',
									'<li>出厂编号：', info.factoryCode, '</li>',
									'<li>监控编号：', id, '</li>',
									'<li>采集时间：', info.collectTime, '</li>',
									'<li>当前状态：', statusName, "<span style='margin-left:3vw;'>累计作业面积：" + info.sumArea + '亩</span></li>',
									'<li>当前位置：', info.currentLocation, '</li></ul>',
									'<button class="DetailBtn viewMoreDialog" onclick="viewHistory()">历史作业</button>',
									'<button class="Cancel" style="display:none"></button>',
									'</div>'
								]
							}
						}

						var options = {
							single: true,
							width: 430,
							height: 405,
							custom: false,
							dx: 0,
							dy: 0,
							autoPan: false,
							eventsPropagation: true,
							title: '农机信息',
							content: content.join('')
						}
						targetPolygon.setInfoWindow(options)
						targetPolygon.openInfoWindow()

					}, error => {
						console.lgo(error)
					})
				}
				this.TalksMap.map.panTo(e.coordinate)
			},
			// 查看历史
			viewHistory() {
				this.historyDialog = true;
			},
			// 查看当天
			viewCurrentLine() {
				let this_ = this;
				this.dialogMapDetail = true;
				this.$refs.trackLayer.getGjTime = '';
				this.$refs.trackLayer.getCenterPos();
				this.$nextTick(function() {
					this.$refs.trackLayer.dataTitle = this.dataTitle;
					this.$refs.trackLayer.initMap();
					if(this.njStatus == 0) {
						this.statusStatic = true
						this.$refs.trackLayer.trackViewing(); //当天静止状态 (历史)
					} else {
						this.statusStatic = false
						this.$refs.trackLayer.trackMove(true); //当天运动状态 (实时)
						// 定时器增量加载实时数据
						this.requestTimer = setInterval(() => {
							this_.$refs.trackLayer.trackMove(false)
						}, 10000)
					}
				})
			},
			// 获取热力图数据
			getHeatLayer() {
				var this_ = this;
				var parmse = {}
				Api.doPost(
					Http.homePageStatisByJSController.countNjHeatMap, {
						catThreeCode:this.catThreeCode
					},
					false,
					res => {
						this.allData = res.result;
						this.setHeatLayer();
					}
				)
			},
			setHeatLayer() {
				this.allHeatLayer.show()
				this.allHeatLayer.setData(this.allData)
				let opt = {
					0.4: 'blue',
					0.6: 'cyan',
					0.9: 'yellow',
					1.0: 'red'
				}
				this.allHeatLayer.config({
					'radius': 5,
					'blur': 6,
					'gradient': opt
				})
			},
			// 获取markers数据
			getMarkers(data) {
				let collectTimeBegin = this.getNowFormatDates() + ' 00:00:00'
				Api.doPost(
					Http.homePageStatisByJSController.getCurrentGpsPoint, {
						xmin: data.xmin,
						ymin: data.ymin,
						xmax: data.xmax,
						ymax: data.ymax,
						ymax: data.ymax,
						catThreeCode:this.catThreeCode
					},
					false,
					res => {
						this.setMarkersData = res.result
						this.setMarkers();
					}
				)
			},
			setMarkers() {
				let this_ = this;
        this.allHeatLayer.hide(); //隐藏热力图
				this.setMarkersData.forEach(function(item, index) {
					let lngLat = [item[0], item[1]];
					let imgUrl;
					if(item[3] == 1) { //运动
						if(item[6] == '1') {//轮式拖拉机
							imgUrl = require('../../../static/img/mapIcon/tlj_on_icon.png')
						} else if(item[6] == '2') {//履带式拖拉机
							imgUrl = require('../../../static/img/mapIcon/lvdai_on_icon.png')
						} else if(item[6] == '3') {//自走式旋耕机
							imgUrl = require('../../../static/img/mapIcon/xuangeng_on_icon.png')
						}else if(item[6] == '4') {//履带自走式耕作机
							imgUrl = require('../../../static/img/mapIcon/gengzuo_on_icon.png')
						} else if(item[6] == '5') {//乘坐式插秧机
							imgUrl = require('../../../static/img/mapIcon/chayang_on_icon.png')
						} else if(item[6] == '6') {//水稻抛秧机
							imgUrl = require('../../../static/img/mapIcon/paoyang_on_icon.png')
						} else if(item[6] == '7') {//自走式穴播机
							imgUrl = require('../../../static/img/mapIcon/xuebo_on_icon.png')
						} else if(item[6] == '8') {//秧苗移栽机
							imgUrl = require('../../../static/img/mapIcon/yizai_on_icon.png')
						} else if(item[6] == '9') {//自走式喷杆喷雾机
							imgUrl = require('../../../static/img/mapIcon/penwuji_on_icon.png')
						} else if(item[6] == '10') {//植保无人机
							imgUrl = require('../../../static/img/mapIcon/wurenji_on_icon.png')
						}  else if(item[6] == '11') {//谷物联合收割机
							imgUrl = require('../../../static/img/mapIcon/gws_on_icon.png')
						} else if(item[6] == '12') {//玉米收获机
							imgUrl = require('../../../static/img/mapIcon/yms_on_icon.png')
						} else if(item[6] == '13') {//花生收获机
							imgUrl = require('../../../static/img/mapIcon/hss_on_icon.png')
						}  else if(item[6] == '14') {//薯类收获机
							imgUrl = require('../../../static/img/mapIcon/shuleish_on_icon.png')
						}  else if(item[6] == '15' || item[6] == '23') {//油菜籽收获机
							imgUrl = require('../../../static/img/mapIcon/czs_on_icon.png')
						}  else if(item[6] == '16') {//甘蔗收获机
							imgUrl = require('../../../static/img/mapIcon/gzs_on_icon.png')
						}  else if(item[6] == '17') {//棉花收获机
							imgUrl = require('../../../static/img/mapIcon/mhs_on_icon.png')
						}  else if(item[6] == '18') {//果类收获机
							imgUrl = require('../../../static/img/mapIcon/guoleish_on_icon.png')
						}else if(item[6] == '19') {//青(黄)饲料收获机
							imgUrl = require('../../../static/img/mapIcon/sls_on_icon.png')
						} else if(item[6] == '20') {//自走式打捆机
							imgUrl = require('../../../static/img/mapIcon/dakun_on_icon.png')
						}else if(item[6] == '21') {//割晒机
							imgUrl = require('../../../static/img/mapIcon/geshai_on_icon.png')
						}else if(item[6] == '22') {//辅助驾驶
							imgUrl = require('../../../static/img/mapIcon/fzjs_on_icon.png')
						}else if(item[6] == '24') {//平地机
							imgUrl = require('../../../static/img/mapIcon/pingdi_on_icon.png')
						}else{//轮式拖拉机
							imgUrl = require('../../../static/img/mapIcon/tlj_on_icon.png')
						}
					} else {
            if(item[6] == '1') {//轮式拖拉机
							imgUrl = require('../../../static/img/mapIcon/tlj_icon.png')
						} else if(item[6] == '2') {//履带式拖拉机
							imgUrl = require('../../../static/img/mapIcon/lvdai_icon.png')
						} else if(item[6] == '3') {//自走式旋耕机
							imgUrl = require('../../../static/img/mapIcon/xuangeng_icon.png')
						}else if(item[6] == '4') {//履带自走式耕作机
							imgUrl = require('../../../static/img/mapIcon/gengzuo_icon.png')
						} else if(item[6] == '5') {//乘坐式插秧机
							imgUrl = require('../../../static/img/mapIcon/chayang_icon.png')
						} else if(item[6] == '6') {//水稻抛秧机
							imgUrl = require('../../../static/img/mapIcon/paoyang_icon.png')
						} else if(item[6] == '7') {//自走式穴播机
							imgUrl = require('../../../static/img/mapIcon/xuebo_icon.png')
						} else if(item[6] == '8') {//秧苗移栽机
							imgUrl = require('../../../static/img/mapIcon/yizai_icon.png')
						} else if(item[6] == '9') {//自走式喷杆喷雾机
							imgUrl = require('../../../static/img/mapIcon/penwuji_icon.png')
						} else if(item[6] == '10') {//植保无人机
							imgUrl = require('../../../static/img/mapIcon/wurenji_icon.png')
						}  else if(item[6] == '11') {//谷物联合收割机
							imgUrl = require('../../../static/img/mapIcon/gws_icon.png')
						} else if(item[6] == '12') {//玉米收获机
							imgUrl = require('../../../static/img/mapIcon/yms_icon.png')
						} else if(item[6] == '13') {//花生收获机
							imgUrl = require('../../../static/img/mapIcon/hss_icon.png')
						}  else if(item[6] == '14') {//薯类收获机
							imgUrl = require('../../../static/img/mapIcon/shuleish_icon.png')
						}  else if(item[6] == '15' || item[6] == '23') {//油菜籽收获机
							imgUrl = require('../../../static/img/mapIcon/czs_icon.png')
						}  else if(item[6] == '16') {//甘蔗收获机
							imgUrl = require('../../../static/img/mapIcon/gzs_icon.png')
						}  else if(item[6] == '17') {//棉花收获机
							imgUrl = require('../../../static/img/mapIcon/mhs_icon.png')
						}  else if(item[6] == '18') {//果类收获机
							imgUrl = require('../../../static/img/mapIcon/guoleiish_icon.png')
						}else if(item[6] == '19') {//青(黄)饲料收获机
							imgUrl = require('../../../static/img/mapIcon/sls_icon.png')
						} else if(item[6] == '20') {//自走式打捆机
							imgUrl = require('../../../static/img/mapIcon/dakun_icon.png')
						}else if(item[6] == '21') {//割晒机
							imgUrl = require('../../../static/img/mapIcon/geshai_icon.png')
						}else if(item[6] == '22') {//辅助驾驶
							imgUrl = require('../../../static/img/mapIcon/fzjs_icon.png')
						}else if(item[6] == '24') {//平地机
							imgUrl = require('../../../static/img/mapIcon/pingdi_icon.png')
						}else{//轮式拖拉机
							imgUrl = require('../../../static/img/mapIcon/tlj_icon.png')
						}
					}

					var point = new maptalks.Marker(
						item, {
							visible: true,
							editable: true,
							cursor: 'pointer',
							shadowBlur: 0,
							shadowColor: 'black',
							draggable: false,
							dragShadow: false, // display a shadow during dragging
							drawOnAxis: null, // force dragging stick on a axis, can be: x, y
							'symbol': [{
								'markerFile': imgUrl,
								'markerWidth': 40,
								'markerHeight': 57,
								'markerDx': 0,
								'markerDy': 0,
								'markerOpacity': 1
							}],
							properties: {
								id: item[4],
								obj: item[3]
							}
						}
					);
					point.on('click', this_.displayInfoWindow)
					point.addTo(this_.allPointLayer)
				})
			},
			// 关闭弹框
			dialogMapDetailClick() {
				this.dialogMapDetail = false
				this.historyDialog = false
				let childLayer = this.$refs.trackLayer;
				let childLayerMap = this.$refs.trackLayer.TalksMapDialog;
				if(childLayerMap._timer || childLayerMap.i > 0) {
					clearInterval(childLayerMap._timer);
					childLayerMap.i = 0
					childLayerMap._timer = ''
				}
				childLayerMap.lastLineLayer.clear()
				childLayerMap.carPoint.clear()
				childLayerMap.fist = true
				childLayerMap.lineLog = []
				childLayerMap.lastLinePoints = []
				childLayerMap.btnName = ''
				childLayer.operationForPauseAndContinue = 'start'
				document.getElementById("pauseBtns").innerHTML = "开始";
				childLayer.continueOrStopUrl = childLayer.kaishi;
				childLayer.calendarFlag = true
				if(this.requestTimer) {
					clearInterval(this.requestTimer);
					this.timer = null;
				}

			}
		}
	}
</script>

<style scoped>
  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
    width:3px;
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
    border-radius:10px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius:10px;
    background:#0A63C6;
    -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
  }
  .tab-box {
		width: 98%;
		margin-left: 1%;
		/* margin-bottom: 10px; */
		/* margin-top: 20px; */
		/* display: flex; */
	}
</style>



// WEBPACK FOOTER //
// src/components/TableList/ToolDistributionHeat.vue